import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  value: "",
  selected: ""
}
const _hoisted_2 = ["value", "title"]
const _hoisted_3 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputPhone = _resolveComponent("InputPhone")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formElements, (formElement, idx) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
        (formElement.type === 'heading')
          ? (_openBlock(), _createElementBlock("h3", {
              key: 0,
              class: _normalizeClass(formElement.classes)
            }, _toDisplayString(formElement.label), 3))
          : (formElement.type === 'select')
            ? (_openBlock(), _createBlock(_component_InputSelect, {
                key: 1,
                name: formElement.name,
                label: formElement.label,
                value: formElement.value
              }, {
                default: _withCtx(() => [
                  (formElement.defaultOption)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_1, _toDisplayString(formElement.defaultOption), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formElement.options, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option[formElement.valKey],
                      value: option[formElement.valKey],
                      title: option[formElement.titleKey]
                    }, _toDisplayString(option[formElement.displayKey]), 9, _hoisted_2))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["name", "label", "value"]))
            : (formElement.type === 'textarea')
              ? (_openBlock(), _createBlock(_component_Field, {
                  key: 2,
                  type: "text",
                  name: formElement.name
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("textarea", _mergeProps(field, {
                      placeholder: formElement.label,
                      class: "block w-full border border-silver mb-30 p-10 min-h-150"
                    }), null, 16, _hoisted_3)
                  ]),
                  _: 2
                }, 1032, ["name"]))
              : (formElement.type === 'inputTel')
                ? (_openBlock(), _createBlock(_component_InputPhone, {
                    key: 3,
                    name: formElement.name,
                    label: formElement.label
                  }, null, 8, ["name", "label"]))
                : (_openBlock(), _createBlock(_component_InputText, {
                    key: formElement.name,
                    name: formElement.name,
                    label: formElement.label
                  }, null, 8, ["name", "label"]))
      ], 64))
    }), 128))
  ]))
}